<template>
  <div class="course-list-prepare">
    <div class="c-title c-width">
      <span class="titleLang">备课语言:</span>
      <div class="changeLang" @click.stop.prevent="dropdownLang()">
        <span v-for="lang in langCategories" v-if="lang.languageId == language">{{lang.langName}}</span> 
        <ul v-show="isShow" class="dropdown_content" >
          <li v-for="(language, index) in langCategories" @click.stop.prevent="changeLang(index,language.languageId)">
            <a href="javascrpt:''">{{language.langName}}</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="c-body c-width">
      <div :class="['new-course', {activeBack: ishover == -1}]">
        <span class="icon iconfont icon-jiahao file-icon" @click="createItem"></span>
        <span class="titleLang" >新建课程</span>
        <span class="save-btn" @click="saveAll">全部保存</span>
      </div>
      <div v-for="(course, index) in courseListData">
        <chapter 
            :chaperData="course" 
            :indexData="index" 
            :class="{courseActive: ischoosed==index, titleEditor: isEditor==index}" 
            @selectChapter="chooseCourse"
            @editorTitle="editorTitle"></chapter>
      </div>      
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { ajaxAPI } from '@/utils/ajaxUtil'
import { HYBIRD_URL } from '@/config/url_config'
import EventBus from '@/views/eventBus'
import Chapter from '@/components/Chapter'
export default {
  props: {
    courseListData: {
      type: Array
    },
    isShow: {
      type: Boolean
    }
  },
  components: {
    Chapter
  },
  data () {
    return {
      ischoosed: 0,
      isEditor: -1,
      language: this.$route.params.languageId,
      langCategories:[
        {langName: 'JAVA', languageId: 10},
        {langName: 'HTML / CSS / JS', languageId: 35},
        {langName: 'Python', languageId: 4},
        {langName: 'C', languageId: 11},
        {langName: 'PHP', languageId: 29}
      ],
      // dropdown: false,
      ishover: -1
    }
  },
  created () {
  },
  computed: {
    dropdown: function() {
      // let showStatus = this.isShow || true
      return this.isShow
    }
  },
  watch: {
    status: function () {
      console.log('content:')
    }
  },
  mounted () {
    console.log(this.language == this.langCategories[2].languageId)
    let _this = this
    EventBus.$on('chapterOption', function (index) {
      _this.isEditor = -1
      _this.ischoosed = index
    })
    EventBus.$on('deleteChapter', function (index) {
      _this.ischoosed = 0
    })
  },
  methods: {
    chooseCourse(index) {
      // 切换课程后，上次编辑的课程名称只读
      console.log('ischoosed', this.ischoosed, index)
      this.ischoosed = index
      this.isEditor = -1
    },
    updateCourse(data) {
      console.log(data)
    },
    editorTitle(index) {
      this.isEditor = index
    },
    statusChange() {
    },
    createItem() {
      this.ischoosed = 0
      console.log('----')
      EventBus.$emit('createChapter')
    },
    dropdownLang() {
      EventBus.$emit('showMenu', true)
    },
    changeLang(index,languageId) {
      this.language = languageId
      this.$emit('changeLang', languageId)
      this.chooseCourse(0)
    },
    saveAll(){
      console.log('000')
      this.$emit('saveAll')
    }
  },
  directives: {
  }
}
</script>

<style lang="scss">
*{
  margin: 0;
  padding: 0;
}
.courseActive{
  color: #1FB6FF !important;
  input{
    color: #1FB6FF !important; 
  }
}
.activeBack{
  background: rgba(31, 185, 255, .05)
}
// .titleEditor{
//   input{
//     border: 1px solid #999 !important;
//   }
// }
.flex{
  display:-webkit-flex;
  display:-ms-flex;
  display:flex;
}
.course-list-prepare{
  width: 100%;
  height:100%;
  background: #fff;
  position: relative;
  overflow: auto;
  box-sizing:border-box;
  cursor: pointer;

  .c-width{
    width: 100%;
  }
  .titleLang{
    font-size: 16px;
    color: #879499;
    font-weight: 300;
  }
  .c-title{
    box-sizing:border-box;
    padding: 0 20px 10px;
    border-bottom: 1px solid #D1D3D4;
    text-align: left;
    background: #F8F9FB;
    
    .changeLang{
      dispaly: inline-block;
      position: relative; 
      line-height: 28px;
      color: #1FB6FF;
      font-weight:normal;
      cursor: pointer;
      font-size: 12px;
      box-sizing: border-box;
      margin-top: 10px;
      padding: 0 30px 0 15px;
      width: 147px;
      border: 1px solid #1FB6FF;
      background: url(../../assets/arrow_drop_down.png) no-repeat scroll 120px center transparent;
      background-size: 8px 8px;
      background-color:#fff;
      border-radius: 30px;
      display:inline-block;

      .dropdown_content{
        padding: 0;
        position: absolute;
        top: 40px;
        left:0;
        width: 160px;
        box-shadow: 0 0 4px 0 rgba(179, 229, 255, 1);
        background-color: #FFF;
        z-index:999;

        li{
          border-bottom: 1px solid #D1D3D4;
          padding-top: 6px;
          padding-bottom: 6px;
          text-align: center;
          background-: #fff;

          a{
            display: block;
            height: 28px;
            line-height: 28px;
            color: #1FB6FF;
          }

        }
      }
      .dropdown_content:before{
        position: absolute;
        content:"";
        top:-10px;
        right:20px;
        width:10px;
        height:10px;
        transform-origin: bottom right;
        transform: rotate(-45deg);
        box-shadow: 1px -1px 4px -1px rgba(179, 229, 255, 100);
        background:#fff;
      }      
      .dropdown_content li:hover a{
        border-left: 2px solid #1FB6FF
      }
    }
    .icon-jiahao{
      cursor:pointer;
      display: block;
      margin-right:4px;
    }
  }
  .c-body{
  }
}
.new-course{
  box-sizing: border-box;
  padding: 13px 10px 13px 25px;
  line-height: 28px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  position: relative;

  .file-icon{
    display: inline-block;
    width: 17px;
    height: 16px;
    margin-right:10px;
    color: #1FB6FF; 
  }
  .save-btn{
    border: 1px solid #1FB6FF;
    color: #1FB6FF;
    display: inline-block;
    position: absolute;
    right: 5px;
    line-height: 24px;
    padding-left: 10px;
    padding-right: 10px;
    border-radius: 20px;
    cursor: pointer;    
  }
}

</style>


// WEBPACK FOOTER //
// index.vue?5119c65e